'use client'
import { apiResponseHandler } from '@/shared/api/react-query'
import { useMutation } from '@tanstack/react-query'
import services from '../services'
import { toast } from '@/shared/ui/use-toast'
import { RestorePasswordByEmailDto } from '../../lib'

export function useRestorePasswordByEmail({ onSuccess }: { onSuccess: () => void }) {
  const mutations = useMutation({
    mutationFn: async (params: RestorePasswordByEmailDto) =>
      apiResponseHandler(await services.restorePasswordByEmail(params)),
    onError: (error) => {
      toast({
        variant: 'destructive',
        title: 'Ошибка!',
        description: error?.message || 'Вы не авторизовались!',
      })
    },
    onSuccess: async (res) => {
      if (res) {
        toast({
          variant: 'default',
          title: 'Отправлено сообщение на вашу почту.',
          description: res,
        })
      }
      onSuccess && onSuccess()
    },
  })

  return mutations
}
